module.exports = __webpack_public_path__ + "img/logo_trplus.c87dec7f.svg";